<div>

  <nav class="navbar navbar-expand-lg navbar-light border-bottom">
    <img src="./../../../assets/images/logohori.png" [routerLink]="['/consolidado']" class="pointer imglogo mr-2 img-fluid" />

    <span class="material-icons text-primary"  id="menu-toggle">
      dehaze
    </span>
        
    <div class="collapse navbar-collapse" [ngClass]="{'show': !isCollapsed}" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
        <li class="nav-item dropdown">
          <a class="nav-link no-icon dropdown-toggle" href="#" id="navbarDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="profile-content">
              <label class="profile-name">{{user?.nombre}}</label>
              <label class="profile-date">Última actividad: {{user?.ultimaActividad}}</label>
            </div>
            <img class="profile-img" [src]="urlApi + urlAvatar + user?.avatarImagen" />
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" href="#" [routerLink]="['/editar-perfil']">Perfil</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" target="_blank" href="https://www.cooprio.fin.ec/?page_id=1865">Políticas</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="LogOut()">Salir</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  
  
</div>
<div class="d-flex" id="wrapper">

 

  <div class="border-right" id="sidebar-wrapper">

    <div class="list-group list-group-flush">
      <ng-container *ngFor="let menu of this.menus">
        <a *ngIf="menu?.menuHijos?.length === 0; else elseBlock" [routerLink]="[menu?.ruta] " (click)="OcultaMenu()"
          routerLinkActive="router-link-active" class="list-group-item list-group-item-action" >
          <span class="material-icons mr-2">{{menu?.icon}}</span>
          {{menu?.nombre}}
        </a>
        <ng-template #elseBlock>
          <span class="list-group-item list-group-item-action pr-2" (click)="menu.mostrarHijos = !menu.mostrarHijos"
            [ngClass]="{'opened-icon': menu.mostrarHijos}">
            <span class="material-icons mr-2">{{menu?.icon}}</span>
            {{menu?.nombre}}
            <span class="material-icons open-icon">chevron_right</span>
          </span>
          <ul class="list-unstyled" *ngIf="menu?.mostrarHijos">
            <li *ngFor="let menuHijo of menu?.menuHijos">
              <a [routerLink]="[menuHijo?.ruta]" routerLinkActive="router-link-active"
                class="list-group-item list-group-item-action" (click)="OcultaMenu()">
                <span class="material-icons mr-2">{{menuHijo?.icon}}</span>
                {{menuHijo?.nombre}}
              </a>
            </li>
          </ul>
        </ng-template>
      </ng-container>
     
      <a class="list-group-item list-group-item-action" (click)="LogOut()">
        <span class="material-icons mr-2">logout</span>
        Cerrar Sesión
      </a>
     
    </div>
    <div class="button-whatsapp mb-4 mr-2">
      <app-contacto-whatsapp></app-contacto-whatsapp>
    </div>
  </div>
  <div id="page-content-wrapper">

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(255,255,255,0.6)" size="large" color="#25476d" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
  </ngx-spinner>

  


